import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { TipiTemplateFormComponent } from './dialogs/form/form.component';
import { TipiTemplateRoutingModule } from './tipi-template-routing.module';
import { TipiTemplateComponent } from './tipi-template.component';



@NgModule({
  declarations: [TipiTemplateComponent, TipiTemplateFormComponent],
  imports: [
    CommonModule,
    TipiTemplateRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    CustomFormControlsModule,
    ResourcefulIndexModule,
  ]
})
export class TipiTemplateModule { }
